var App = App || {};

App.SiteHeader = (function ($) {
    "use strict";

    function init() {
        GlobalNav();
        PrimaryNav();
        MobileNav();
    }

    function GlobalNav() {
        const navGroups = $(".global-navigations-group");
        const ddGroupButtons = $(".global-dropdown-group > .btn");
        const ddMenuClose = $(".global-dropdown-menu button.close");
        const ddMenus = $(".global-dropdown-menu")
        const globalDdBackdrop = $(".global-dropdown-backdrop");
        const profileBackdrop = $(".global-dropdown-backdrop.profile-backdrop");

        //ensure menus appear in front of succeeding buttons
        var groupZIndex = 1002;
        $(navGroups.get().reverse()).each(function () {
            $(this).css("z-index", groupZIndex);
            groupZIndex++;
        });
        profileBackdrop.css("z-index", groupZIndex);

        ddGroupButtons.on("click", function () {
            GlobalDdClose();
            GlobalDdOpen($(this));
        });

        ddMenuClose.add(globalDdBackdrop).on("click", function () {
            GlobalDdClose();
        });

        ddMenus.keydown(function (e) {
            //esc
            if (e.keyCode === 27) {
                GlobalDdClose();
            }
            // tab
            if (e.keyCode === 9) {

                if (!e.shiftKey) {
                    //return to close button on the last link in list
                    if ($(e.target)[0] == $(this).find("a, button").last()[0]) {
                        e.preventDefault();
                        $(this).find(".btn.close").focus();
                    }
                }
                else {
                    //close dropdown when reverse tabbing from close button
                    if ($(e.target)[0] == $(this).find(".btn.close")[0]) {
                        GlobalDdClose();
                    }
                }
            }
        });
    }
    function PrimaryNav() {

        var hovering = false;
        var megaMenuSpeed = 300;

        var selectorMenu = $(".site-header-primary > nav > ul");
        var selectorItem = $(".site-header-primary > nav > ul").children("li").children("a, button");

        var level2Menu = [];
        var level2MenuWhich = 0;
        var level2MenuItems = $(".site-header-primary > nav > ul").children("li").find(".mega-menu").find("a, button");

        $(".site-header-primary").find(".mega-menu").each(function () {
            $(this).find("a").attr("tabindex", -2);
        });;

        /**********************************************************************************
         ENTIRE MENU END HOVER
        /*********************************************************************************/
        selectorMenu.hover(
            function () {

            },
            function () {
                hovering = false;
                selectorItem.blur();
                //MmOpen($(this).children("li").children("a"), megaMenuSpeed);
            }
        );

        /**********************************************************************************
         LEVEL ONE ITEM HOVER
        /*********************************************************************************/
        selectorItem.hover(
            function () {
                if (hovering !== true) {
                    MmOpen($(this), megaMenuSpeed);
                }
                else {
                    MmOpen($(this), 1);
                }
                hovering = true;
            },
            function () { }
        );

        /**********************************************************************************
         LEVEL ONE ITEM FOCUS
        /*********************************************************************************/
        selectorItem.focus(function () {
            MmOpen($(this), 1);
            hovering = true;
        });

        /**********************************************************************************
         LEVEL ONE ITEM BLUR
        /*********************************************************************************/
        selectorItem.blur(function () {
            if (hovering === false) {
                MmClose($(this), megaMenuSpeed);
            }
        });

        /**********************************************************************************
         LEVEL ONE ITEM ARROWS
        /*********************************************************************************/
        selectorItem.keydown(function (e) {
            // right arrow
            if (e.keyCode === 39) {
                e.preventDefault();
                $(this).parent("li").next("li").children("a, button").focus();
            }
            // left arrow
            else if (e.keyCode === 37) {
                e.preventDefault();
                $(this).parent("li").prev("li").children("a, button").focus();
            }
            // down arrow
            else if (e.keyCode === 40) {
                hovering = true;
                e.preventDefault();
                level2Menu = [];
                $(this).siblings(".mega-menu").find("a:visible, button:visible").each(function () { level2Menu.push(this); });
                level2MenuWhich = 0;
                $(level2Menu[level2MenuWhich]).focus();
            }
            // esc
            else if (e.keyCode === 27) {
                var MenuuButton = $(this);
                MmClose(MenuuButton, megaMenuSpeed);
            }
        });

        /**********************************************************************************
         LEVEL 2 ITEMS ARROWS
        /*********************************************************************************/
        level2MenuItems.keydown(function (e) {
            /* right arrow */
            if (e.keyCode === 39) {
                hovering = true;
                e.preventDefault();
                $(this).parents(".mega-menu").parent("li").next("li").children("a, button").focus();
            }
            /* left arrow */
            else if (e.keyCode === 37) {
                hovering = true;
                e.preventDefault();
                $(this).parents(".mega-menu").parent("li").prev("li").children("a, button").focus();
            }
            // down arrow
            else if (e.keyCode === 40) {
                hovering = true;
                e.preventDefault();
                if (level2MenuWhich < level2Menu.length - 1) { level2MenuWhich++; }
                else { level2MenuWhich = 0; }
                $(level2Menu[level2MenuWhich]).focus();
            }
            // up arrow
            else if (e.keyCode === 38) {
                hovering = true;
                e.preventDefault();
                if (level2MenuWhich > 0) { level2MenuWhich--; }
                else { level2MenuWhich = level2Menu.length - 1; }
                $(level2Menu[level2MenuWhich]).focus();
            }
            // esc
            else if (e.keyCode === 27) {
                var MenuButton = $(this).parents(".mega-menu").siblings("a, button");
                MmClose(MenuButton, megaMenuSpeed);
            }
        });

        /**********************************************************************************
         ENTIRE EVERYTHING KEYPRESS - should we close that menu??
        /*********************************************************************************/
        selectorMenu.keydown(function (e) {
            if (e.keyCode === 9) {
                hovering = false;
                MmClose($(this).children("li").children("a, button"), 1);
            }
        });
    }

    function MobileNav() {/**********************************************************************************
         Mobile Navigation
        /*********************************************************************************/
        var lvl1Menu = $("#site-header-mobile-menu-offcanvas"),
            mobileLevel2Buttons = $(".mobile-nav-btn-lvl2"),
            lvl2Nav = $(".offcanvas.offcanvas-lvl2");

        //lvl1Menu.appendTo("body");

        mobileLevel2Buttons.click(function () {
            var lvl2Offcanvas = new bootstrap.Offcanvas(document.getElementById($(this).attr("data-bs-target")));
            lvl2Offcanvas.show();

            //away class indicates lvl 1 menu is not in  view. data-lvl2-visited tracks last lvl 3 menu viewed
            lvl1Menu.addClass("away").attr("data-lvl2-visited", $(this).attr("data-bs-target"));
        });

        lvl2Nav.on('shown.bs.offcanvas', function () {
            $(this).find(".btn-back").focus();
        });

        lvl2Nav.on('hide.bs.offcanvas', function () {
            //prevent focus of menu button when using keyboard nav to returning to lvl 1 menu
            $(".btn-mobile-menu").addClass("anti-focus");
        });

        //close both mobile nav menus when lvl2 close is clicked
        $(".offcanvas-lvl2 .btn-close").click(function () {
            lvl1Menu.addClass("cascade-close");
        });

        lvl2Nav.on('hidden.bs.offcanvas', function () {
            if (lvl1Menu.hasClass("cascade-close")) {
                lvl1Menu.removeClass("cascade-close");
                $("#site-header-mobile-menu-offcanvas.show .btn-close.lvl1-close").click();
            } else {
                //data-bs-focus never works for first dismissal, but will after sometimes
                //here we force focus to last opened lvl 2 button even if button focus fails
                lvl1Menu.find(".mobile-nav-btn-lvl2[data-bs-target=" + lvl1Menu.attr("data-lvl2-visited") + "]").focus();
            }
        });

        lvl1Menu.on('hide.bs.offcanvas', function () {
            if (lvl1Menu.hasClass("away")) {
                //indicate lvl 1 is currently being viewed
                lvl1Menu.removeClass("away");
            }
            else {
                //allow header mobile nav button to be focused
                $(".btn-mobile-menu").removeClass("anti-focus").focus();
            }
        });

        $(document).on("focus", ".anti-focus", function () {
            //bootstrap defaults focusing header mobile nav button despite data-bs-focus being set to false (likely bug)
            //instead, when appropriate, we redirect focus to lvl 2 link associated with last opened lvl 3 menu
            lvl1Menu.find(".mobile-nav-btn-lvl2[data-bs-target=" + lvl1Menu.attr("data-lvl2-visited") + "]").focus();
        })
    }

    function GlobalDdOpen(Button) {
        Button.siblings(".global-dropdown-menu").attr("aria-hidden", false).removeAttr("hidden");

        setTimeout(function () {
            Button.attr("aria-expanded", "true").siblings(".global-dropdown-menu").addClass("show").find("a, button").attr("tabindex", 0);
            Button.siblings(".global-dropdown-menu").find(".btn.close").focus();
            if (Button.hasClass("btn-profile")) {
                $(".profile-backdrop").addClass("visible");

            } else {
                $(".global-navigation-backdrop").addClass("visible");
            }
        }, 10);
    }

    function GlobalDdClose() {
        var closedBtn = $(".global-dropdown-group > .btn[aria-expanded=true]");
        var shownMenu = $(".global-dropdown-menu.show");
        $(".global-dropdown-group > .btn").attr("aria-expanded", "false");
        shownMenu.removeClass("show").attr("aria-hidden", true).find("a, button").attr("tabindex", -1);
        $(".global-dropdown-backdrop").removeClass("visible");

        setTimeout(function () {
            closedBtn.focus();
            shownMenu.attr("hidden", true); // aria hidden is not respected, so hidden attribute is applied once animation finishes
        }, 150);
    }

    function MmOpen(Menu, Speed) {
        Menu.attr("aria-expanded", "true").addClass("active").siblings(".mega-menu").stop().slideDown(Speed);
        MmClose(Menu.parents("li").siblings("li").children("a, button"), Speed);
        Menu.parents("li").siblings("li").children("a, button").removeClass("active");
        $(".mm-backdrop").addClass("visible");
    }

    function MmClose(Menu, Speed) {
        Menu.parents("li").siblings("li.default").children("a, button").addClass("active");
        Menu.attr("aria-expanded", "false").removeClass("active").siblings(".mega-menu").stop().slideUp(Speed);
        $(".mm-backdrop").removeClass("visible");
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SiteHeader.init();
});